import { isEqualWith } from 'lodash';
import { ImageSpecification } from '../../feed-images-types';

export const areImageSpecsEqual = (
  firstSpec: ImageSpecification,
  secondSpec: ImageSpecification
) =>
  isEqualWith(firstSpec, secondSpec, (_a, _b, key) => {
    if (key === 'specificationId' || key === 'shotType') {
      return true;
    }
    return undefined;
  });

export const getImageSpecLabel = (item: ImageSpecification) => {
  const labelParts: string[] = [];

  if (item.bestAvailable) return 'Best Available';

  labelParts.push(`${item.width}x${item.height}`);

  if (item.outputType || item.outputType === null) {
    const typeLabel = item.outputType ? item.outputType.toUpperCase() : 'JPG';
    labelParts.push(`${item.transparent ? 'Transparent ' : ''}${typeLabel}`);
  }

  if (item.crop) {
    labelParts.push(
      `Cropped ${item.ensureDimensions ? '(Ensure Dimensions)' : ''}`
    );
  }

  if (item.dpiX > 0 || item.dpiY > 0) {
    if (item.dpiX === item.dpiY) {
      labelParts.push(`(@${item.dpiX} dpi)`);
    } else {
      labelParts.push(`(@${item.dpiX}x${item.dpiY} dpi)`);
    }
  }

  if (item.quality) {
    labelParts.push(`Quality: ${item.quality}%`);
  }

  if (item.sizeInBytes) {
    labelParts.push(`Max Size: ${item.sizeInBytes} byte(s)`);
  }

  if (item.prohibitUpscale) {
    labelParts.push('Upscaling prohibited');
  }

  if (item.backgroundColour) {
    labelParts.push(`Colour: ${item.backgroundColour}`);
  }

  if (item.borderId > 0) {
    labelParts.push(`Border: ${item.borderId}`);
  }

  if (item.outputProfile) {
    labelParts.push(`Profile: ${item.outputProfile}`);
  }

  if (item.pixelFormat) {
    labelParts.push(`Pixel Format: ${item.pixelFormat}`);
  }

  if (item.preserveMetadata) {
    labelParts.push('Preserve metadata');
  }

  return labelParts.join(', ');
};
